/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import { findChild, type VdomParent } from '../../common/utils/vdom';
import { slug } from '../../common';
import app from 'flarum/forum/app';

/**
 * The `Hero-title` vnode, whose text node is swapped for trusted HTML.
 *
 * `text` is not part of the shared `VdomElement` shape, so it is described here.
 */
export interface HeroTitleVnode {
	children?: unknown;
	text?: string;
}

export default function () {
	extend(WelcomeHero.prototype, 'view', function (vnode) {
		if (app.forum.attribute<boolean>(`${slug}.allow_html_in_hero`)) {
			const title = findChild(vnode as unknown as VdomParent, 'Hero-title', true) as HeroTitleVnode | undefined;
			if (title) {
				title.children = [m.trust(title.text!)];
				delete title.text;
			}
		}
	});
}
